import { SYNC_KEY_PROYECTOS_SNAPSHOTS } from "../../../constantes";
import { ProyectosPlataformaService, SnapshotProyectoItem } from "../../../shared/generated/grpc/plataforma_proyectos_pb";
import { SnapshotResponse } from "../../../shared/response/proyectos/SnapshotResponse";
import { SnapshotIpcRealPayload } from "../../../shared/services/api/payload/proyectos/SnapshotPayload";
import { ServiceGetListBase } from "../../../shared/services/base/ServiceGetListBase";
import { grpcCall, grpcClient } from "../../../shared/services/grpc/grpcCall";

/** Snapshots de parámetros económicos (`ProyectosPlataformaService`, gRPC): listado en memoria + activo. */
export class SnapshotService extends ServiceGetListBase<SnapshotResponse> {
  static readonly instance = new SnapshotService();
  private constructor() { super(); }

  /** Clave única del listado: deduplica `sync()` (dos pedidos simultáneos, un solo request). */
  protected readonly syncKey = SYNC_KEY_PROYECTOS_SNAPSHOTS;

  /** gRPC-Web (`ListSnapshots`): no eliminados, del año más reciente al más antiguo. */
  protected async fetchItems(): Promise<SnapshotResponse[]> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).listSnapshots({}));
    return r.items.map(toSnapshotResponse);
  }

  /** Snapshot vigente (o null si no hay ninguno activado). */
  async getActivo(): Promise<SnapshotResponse | null> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).getSnapshotActivo({}));
    return r.snapshot ? toSnapshotResponse(r.snapshot) : null;
  }

  /** Desactiva todos los anteriores y activa este (`ActivarSnapshot`). */
  async activar(id: string): Promise<SnapshotResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).activarSnapshot({ id }));
    return this._persist(toSnapshotResponse(r));
  }

  /** Registra el IPC real (DANE) (`ActualizarIpcReal`). */
  async setIpcReal(id: string, payload: SnapshotIpcRealPayload): Promise<SnapshotResponse> {
    const r = await grpcCall(() => grpcClient(ProyectosPlataformaService).actualizarIpcReal({ id, ipcReal: payload.ipcReal }));
    return this._persist(toSnapshotResponse(r));
  }

  // Tras activar/ipc-real el servidor puede haber cambiado `activo` de otros snapshots:
  // se recarga la lista completa para reflejarlo.
  private async _persist(item: SnapshotResponse): Promise<SnapshotResponse> {
    this.upsert(item);
    await this.sync().catch(() => {});
    return this.items.find((s) => s.id === item.id) ?? item;
  }
}

/** Mensaje gRPC del snapshot → `SnapshotResponse`. Lo reusa el guardado. */
export function toSnapshotResponse(s: SnapshotProyectoItem): SnapshotResponse {
  return {
    id: s.id,
    isEliminado: false,
    año: s.anio,
    smmlv: Number(s.smmlv),
    subsidioTransporte: Number(s.subsidioTransporte),
    factorJornal: Number(s.factorJornal),
    ipc: s.ipc,
    ipcReal: s.ipcReal ?? null,
    nota: s.nota ?? null,
    activo: s.activo,
    totalProyectos: s.totalProyectos,
    createdAt: Number(s.createdAt),
  };
}
